import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {type RetailLocationTemplateConfiguration, retailLocationTemplateConfigurationValidator} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/retailLocationsWorkspaceCapability/domain/RetailLocationTemplateConfiguration";
import {z as zod} from "zod";

export type RetailLocationsWorkspaceCapabilityConfiguration = {
    retailLocationTemplates: Record<Uuid, {
        configuration: RetailLocationTemplateConfiguration;
        organizationalUnitColumnId: Uuid;
        statusColumnId: Uuid;
        organizationalUnitTemplateId: Uuid;
    }>;
};

export const retailLocationsWorkspaceCapabilityConfigurationValidator: zod.ZodType<RetailLocationsWorkspaceCapabilityConfiguration> = zod.strictObject({
    retailLocationTemplates: zod.record(uuidZodValidator, zod.strictObject({
        configuration: retailLocationTemplateConfigurationValidator,
        organizationalUnitColumnId: uuidZodValidator,
        statusColumnId: uuidZodValidator,
        organizationalUnitTemplateId: uuidZodValidator,
    })),
});
